import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

const CollateralKeywordOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)
  const [wordTypeOptions, setWordTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [wordType, setWordType] = useState(optionalData.wordType || 0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    api.GET_SETTINGS_REGULATED_WORDS_BY_TYPES_AND_CATEGORY(
      2000, // UCC Filing SourceTypeId
      -1,
      -1,
      wordType,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .map((item) => ({
              ...item,
              Id: item.RegulatedWordId,
              Name: `${item.RegulatedWordTypeName} - ${item.Word}`,
            }))
            .sort((a, b) => (a.Name > b.Name ? 1 : -1)),
        })
        dispatch({
          type: SET_OPTIONAL_DATA,
          optionalData: {
            wordType,
          },
        })
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }, [wordType])

  const getWordTypeOptions = () => {
    api.GET_REGULATED_WORD_TYPES(
      (res) => {
        setWordTypeOptions([
          { label: 'All', value: '0' },
          ...res
            .filter((a) => a.Name === 'Regulated')
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
      },
      (err) => {
        console.error(err)
      }
    )
  }

  useEffect(() => {
    getWordTypeOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Collateral Keyword Type"
        noPlaceholder
        value={wordType}
        onChange={(val) => {
          setWordType(val)
        }}
        options={wordTypeOptions}
      />
      {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default CollateralKeywordOptions
